const apiBase = process.env.REACT_APP_ZOOM_API_BASE || '';

async function handleResponse(res) {
  let payload = {};
  try {
    payload = await res.json();
  } catch {
    payload = {};
  }
  if (!res.ok) {
    const err = new Error(payload?.error || 'Request failed.');
    err.code = payload?.code || null;
    throw err;
  }
  return payload;
}

export async function login({ email, password }) {
  const res = await fetch(`${apiBase}/api/users/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }),
  });
  return handleResponse(res);
}

export async function verifyMagicLink(token) {
  const res = await fetch(`${apiBase}/api/auth/verify-magic-link`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  });
  return handleResponse(res);
}

export async function setPassword(token, password) {
  const res = await fetch(`${apiBase}/api/auth/set-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token, password }),
  });
  return handleResponse(res);
}

export async function resendWelcome(email) {
  const res = await fetch(`${apiBase}/api/auth/resend-welcome`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  });
  return handleResponse(res);
}
